import React from "react";
import styled from "styled-components/macro";
import BeehiveImg from "lib/images/beehive.png";
import { SecondaryButton, PrimaryButton } from "@loanbossinc/component-library";
import { GroupedButtons, SearchBar } from "components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2em 10em;
  max-width: ${(({ maxWidth }) => maxWidth ?? "1920px")};
  min-width: 1230px;
`;

const IntroWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;

const IntroSectionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const ImageTextWrapper = styled.div`
  display: inherit;
  flex-direction: row;
  justify-content: flex-start;
`;

const Image = styled.img`
  object-fit: contain;
`;

const GuidingText = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2em;
  max-width: 75%;
  gap: 1em;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.25em;
`;

const ContextText = styled.div`
  font-size: 16px;
  font-weight: 400;
  width: 75%;
  display: inherit;
  flex-direction: column;
  gap: 1em;
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 235px;
`;

const FilterWrapper = styled.div`
  padding: 1em 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  && > div:first-child {
    width: 60%;
  }
  && > div:last-child {
    width: 25%;
  }
`;

const EdcDashboardHeader = ({
  setModalOpened,
  selectedDashboardView,
  setSelectedDashboardView,
  searchText,
  setSearchText,
  campaignStatusOptions,
  handleContactListClicked,
  maxWidth
}) => {
  const buttonStyles = { width: "235px", borderRadius: "8px" };

  return (
    <Container maxWidth={maxWidth}>
      <IntroWrapper>
        <IntroSectionWrapper>
          <ImageTextWrapper>
            <Image src={BeehiveImg} />
            <GuidingText>
              <TitleWrapper>Email Engagement Manager</TitleWrapper>
              <ContextText>
                <span>Use the Engagement Manager as a touchpoint between you and your clients.</span>
                <span>Create an email to get started.</span>
              </ContextText>
            </GuidingText>
          </ImageTextWrapper>
          <ButtonsContainer>
            <PrimaryButton
              label="Create Email"
              style={buttonStyles}
              onClick={() => setModalOpened(true)}
            />
            <SecondaryButton
              label="Contact list"
              style={buttonStyles}
              onClick={() => handleContactListClicked()}
            />
          </ButtonsContainer>
        </IntroSectionWrapper>
      </IntroWrapper>
      <FilterWrapper>
        <SearchBar
          searchText={searchText}
          setSearchText={setSearchText}
          marginLeft={0}
          placeholder="Search emails by name"
        />
        <GroupedButtons
          primaryColor="#5F6368"
          roundedBorder
          options={campaignStatusOptions}
          selected={selectedDashboardView}
          setFilter={setSelectedDashboardView}
          textStyle="uppercase"
          disablePadding
          width="300px"
          compareValue
          containerPadding={0}
          containerHeight={53}
        />
      </FilterWrapper>
    </Container>
  );
};

export default EdcDashboardHeader;
